import { createThunkEffect } from "../../utilities/ActionUtility";
import * as ContractEffect from "./ContractEffect";

// contract types
export const REQUEST_ALL_CONTRACT_TYPES = "ContractEffect.REQUEST_ALL_CONTRACT_TYPES";
export const REQUEST_ALL_CONTRACT_TYPES_FINISHED = "ContractEffect.REQUEST_ALL_CONTRACT_TYPES_FINISHED";

export function requestAllContractTypes() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_CONTRACT_TYPES, ContractEffect.requestAllContractTypes);
    };
}

export const REQUEST_ADD_CONTRACT_TYPE = "ContractEffect.REQUEST_ADD_CONTRACT_TYPE";
export const REQUEST_ADD_CONTRACT_TYPE_FINISHED = "ContractEffect.REQUEST_ADD_CONTRACT_TYPE_FINISHED";

export function addContractType(type) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADD_CONTRACT_TYPE, ContractEffect.addContractType, type);
    };
}

export const REQUEST_UPDATE_CONTRACT_TYPE = "ContractEffect.REQUEST_UPDATE_CONTRACT_TYPE";
export const REQUEST_UPDATE_CONTRACT_TYPE_FINISHED = "ContractEffect.REQUEST_UPDATE_CONTRACT_TYPE_FINISHED";

export function updateContractType(id, type) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_UPDATE_CONTRACT_TYPE, ContractEffect.updateContractType, id, type);
    };
}

// information products
export const REQUEST_ALL_INFORMATION_PRODUCTS = "ContractEffect.REQUEST_ALL_INFORMATION_PRODUCTS";
export const REQUEST_ALL_INFORMATION_PRODUCTS_FINISHED = "ContractEffect.REQUEST_ALL_INFORMATION_PRODUCTS_FINISHED";

export function requestAllInformationProducts() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_INFORMATION_PRODUCTS, ContractEffect.requestAllInformationProducts);
    };
}

export const REQUEST_ADD_INFORMATION_PRODUCT= "ContractEffect.REQUEST_ADD_INFORMATION_PRODUCT";
export const REQUEST_ADD_INFORMATION_PRODUCT_FINISHED = "ContractEffect.REQUEST_ADD_INFORMATION_PRODUCT_FINISHED";

export function addInformationProduct(product) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADD_INFORMATION_PRODUCT, ContractEffect.addInformationProduct, product);
    };
}

export const REQUEST_UPDATE_INFORMATION_PRODUCT= "ContractEffect.REQUEST_UPDATE_INFORMATION_PRODUCT";
export const REQUEST_UPDATE_INFORMATION_PRODUCT_FINISHED = "ContractEffect.REQUEST_UPDATE_INFORMATION_PRODUCT_FINISHED";

export function updateInformationProduct(id, product) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_UPDATE_INFORMATION_PRODUCT, ContractEffect.updateInformationProduct, id, product);
    };
}

// contracts
export const REQUEST_ALL_CONTRACTS = "ContractEffect.REQUEST_ALL_CONTRACTS";
export const REQUEST_ALL_CONTRACTS_FINISHED = "ContractEffect.REQUEST_ALL_CONTRACTS_FINISHED";

export function requestAllContracts() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_CONTRACTS, ContractEffect.requestAllContracts);
    };
}

export const REQUEST_ADD_CONTRACT= "ContractEffect.REQUEST_ADD_CONTRACT";
export const REQUEST_ADD_CONTRACT_FINISHED = "ContractEffect.REQUEST_ADD_CONTRACT_FINISHED";

export function addContract(contract) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADD_CONTRACT, ContractEffect.addContract, contract);
    };
}

export const REQUEST_UPDATE_CONTRACT= "ContractEffect.REQUEST_UPDATE_CONTRACT";
export const REQUEST_UPDATE_CONTRACT_FINISHED = "ContractEffect.REQUEST_UPDATE_CONTRACT_FINISHED";

export function updateContract(id, contract) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_UPDATE_CONTRACT, ContractEffect.updateContract, id, contract);
    };
}

// information product vs. subscriptionType relations
export const REQUEST_ALL_RELATIONS = "ContractEffect.REQUEST_ALL_RELATIONS";
export const REQUEST_ALL_RELATIONS_FINISHED = "ContractEffect.REQUEST_ALL_RELATIONS_FINISHED";

export function requestAllRelations() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_RELATIONS, ContractEffect.requestAllRelations);
    };
}

export const REQUEST_ADD_RELATION = "ContractEffect.REQUEST_ADD_RELATION";
export const REQUEST_ADD_RELATION_FINISHED = "ContractEffect.REQUEST_ADD_RELATION_FINISHED";

export function addRelation(relation) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADD_RELATION, ContractEffect.addRelation, relation);
    };
}

export const REQUEST_UPDATE_RELATION = "ContractEffect.REQUEST_UPDATE_RELATION";
export const REQUEST_UPDATE_RELATION_FINISHED = "ContractEffect.REQUEST_UPDATE_RELATION_FINISHED";

export function updateRelation(id, relation) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_UPDATE_RELATION, ContractEffect.updateRelation, id, relation);
    };
}


export const REQUEST_DELETE_RELATION = "ContractEffect.REQUEST_DELETE_RELATION";
export const REQUEST_DELETE_RELATION_FINISHED = "ContractEffect.REQUEST_DELETE_CONTRACT_FINISHED";

export function deleteRelation(id) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_DELETE_RELATION, ContractEffect.deleteRelation, id);
    };
}
